module.exports = __webpack_public_path__ + "img/cont-10-crescita.d657ab93.svg";